import React from "react";

import { PageHeader } from "components/ui/PageHeader";

import { PracticeDetailsForm } from "./components/PracticeDetailsForm/PracticeDetailsForm";
import { PracticeLogoUpload } from "./components/PracticeLogoUpload/PracticeLogoUpload";
import { useAddressAutocomplete } from "./hooks/useAddressAutocomplete";
import { useGoogleMapsScript } from "./hooks/useGoogleMapsScript";
import { usePracticeDetailsForm } from "./hooks/usePracticeDetailsForm";
import styles from "./PracticeDetailsPage.module.css";

const PracticeDetailsPage = () => {
  const {
    formik,
    base64Image,
    displayImage,
    selectLogo,
    applyResolvedAddress,
    changeEircode,
    changeLocation,
    fullAddress,
    isSaving,
  } = usePracticeDetailsForm();

  /*
   * One loader for the page: both the address suggestions on the Details tab and the
   * map on the Location tab need the Maps script, and it must be requested whichever
   * tab the user is looking at.
   */
  const mapsScript = useGoogleMapsScript();

  const autocomplete = useAddressAutocomplete({
    onAddressResolved: applyResolvedAddress,
    mapsScript,
  });

  return (
    <div className={styles.page}>
      <PageHeader title="Practice Details" />

      <PracticeLogoUpload
        imageSource={base64Image || displayImage}
        onFileSelected={selectLogo}
      />

      <PracticeDetailsForm
        formik={formik}
        isSaving={isSaving}
        autocomplete={autocomplete}
        mapsScript={mapsScript}
        fullAddress={fullAddress}
        onEircodeChange={changeEircode}
        onLocationChange={changeLocation}
      />
    </div>
  );
};

export { PracticeDetailsPage };
